import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import {connect} from 'react-redux';
import InventoryList from '../Components/Inventory/inventory-list';
import InventoryItemList from '../Components/Inventory/item-list';
import * as ProjectActionType from '../constants';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

export class ProjectAddEditHomeInventory extends Component {
    static propTypes = {
      match: PropTypes.any,
      projectId: PropTypes.string,
      history: PropTypes.object,
      location: PropTypes.any,
      inventoryItemProfile: PropTypes.object,
      inventoryItemList: PropTypes.array,
      dispatch: PropTypes.func
    }

    onFetchListInventoryItem = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.GET_LIST_INVENTORY_ITEM_ASYNC,
        params: {
          projectId: params.projectId,
          group: params.group,
          groupOrderType: params.groupOrderType,
          search: params.search,
          filter: {
            categories: params.categoryIds
          }
        },
        callback
      });
    }

    onGetInventoryItemProfile = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.GET_INVENTORY_ITEM_PROFILE_ASYNC,
        params: {
          id: params.id
        },
        callback
      });
    }

    onRemoveInventoryItem = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.DELETE_INVENTORY_ITEM_ASYNC,
        params: {
          id: params.id
        },
        callback
      });
    }

    onTabChange = (tab) => {
      const { location, history } = this.props;
      const queryParams = queryString.parse(location.search);
      history.push({
        pathname: location.pathname,
        search: queryString.stringify({
          ...queryParams,
          tab: tab
        })
      });
    }

    render() {
      const {projectId, location, inventoryItemList, inventoryItemProfile, history } = this.props;
      const queryParams = queryString.parse(location.search);
      return (
        <React.Fragment>
          <Tab.Container
            id='left-tabs-example'
            defaultActiveKey='categories'
            className='s1-stack-tab'
            activeKey={queryParams.tab}
            onSelect={this.onTabChange}
          >
            <Row className='clearfix'>
              <Col sm={2} style={{ paddingRight: 0 }}>
                <Nav bsStyle='pills' stacked>
                  <NavItem eventKey='categories'>Inventory</NavItem>
                  <NavItem eventKey='inventoryItem'>Inventory Items</NavItem>
                </Nav>
              </Col>
              <Col sm={10}>
                <Tab.Content
                  unmountOnExit
                  animation
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    border: '1px solid #e6e6e6',
                    backgroundColor: '#fff'
                  }}
                >
                  <Tab.Pane eventKey='categories'>
                    <InventoryList projectId={projectId} />
                  </Tab.Pane>
                  <Tab.Pane eventKey='inventoryItem'>
                    <InventoryItemList
                      projectId={projectId}
                      history={history}
                      onGetInventoryProfile={this.onGetInventoryItemProfile}
                      inventoryItemProfile={inventoryItemProfile}
                      inventoryItemList={inventoryItemList}
                      onFetchListInventoryItem={this.onFetchListInventoryItem}
                      onRemoveInventoryItem={this.onRemoveInventoryItem}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    inventoryItemProfile: state.ProjectStore.inventoryItemProfile,
    inventoryItemList: state.ProjectStore.inventoryItemList
  };
};

export default withRouter(connect(mapStateToProps)(ProjectAddEditHomeInventory));



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-home-inventory.js